import { useLocation } from "react-router-dom";
import ComplianceStrip from "../components/ComplianceStrip";
import Seo from "../components/Seo";
import { LEGAL as content } from "../content/site";

const Legal = () => {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/(legal\/)?/, "").replace(/\/$/, "") || "privacy";
  const c = content[slug] || content.privacy;
  const seoMap = {
    privacy: { title: "Privacy Policy", desc: "How MortgagePath collects, stores and uses your data. Educational guidance only — not regulated advice.", path: "/privacy" },
    cookies: { title: "Cookie Policy", desc: "How MortgagePath uses cookies. Strictly-necessary cookies and optional analytics with consent.", path: "/cookies" },
    terms: { title: "Terms of Use", desc: "Terms of use for MortgagePath. Educational information only — not regulated mortgage advice, not a recommendation, no guarantees.", path: "/terms" },
  };
  const seo = seoMap[slug] || seoMap.privacy;
  return (
    <div className="mp-container py-14 max-w-3xl">
      <Seo title={seo.title} description={seo.desc} path={seo.path} />
      <div className="text-xs uppercase tracking-widest text-[#0F766E]">Legal</div>
      <h1 className="font-sora mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-[#0B1220]">{c.h}</h1>
      <p className="mt-4 text-[#475569] leading-relaxed">{c.intro}</p>
      <div className="mt-8 space-y-6">
        {c.sections.map((s) => (
          <div key={s.h} className="mp-card p-6">
            <h2 className="font-sora text-xl font-semibold text-[#0B1220]">{s.h}</h2>
            <p className="mt-2 text-[#475569] leading-relaxed">{s.b}</p>
          </div>
        ))}
      </div>
      <div className="mt-8"><ComplianceStrip /></div>
    </div>
  );
};

export default Legal;
